<template>
  <div class="page_settlement">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="项目:">
              <el-select v-model="listQuery.projectid" size="small" filterable clearable placeholder="" style="width: 180px;">
                <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申报月:">
              <el-date-picker v-model="listQuery.ownershipMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="邮件标题" size="small" v-if="activeName=='0'">
              <el-input v-model="listQuery.mailSubject" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="发薪状态" size="small" v-if="activeName=='1'">
              <el-select v-model="listQuery.payStatus" placeholder="" clearable filterable style="width:180px">
                <el-option value="发薪成功"></el-option>
                <el-option value="发薪失败"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box" style="padding-left: 25px;">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="90px">
          <div>
            <el-form-item label="编号" size="small">
              <el-input v-model="listQuery.generateNum" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="发送邮箱" size="small">
              <el-input v-model="listQuery.originalSingleSource" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="接收邮箱" size="small">
              <el-input v-model="listQuery.receivingMailbox" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <!-- <el-form-item label="生成结果" size="small">
              <el-select v-model="listQuery.name" placeholder="" clearable filterable style="width:180px">
                <el-option value="成功"></el-option>
                <el-option value="失败"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="开始时间" size="small">
              <el-date-picker v-model="listQuery.acquireTimeStart" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" size="small">
              <el-date-picker v-model="listQuery.acquireTimeEnd" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>结算</el-breadcrumb-item>
          <el-breadcrumb-item>{{activeName=='0' ? '原始单' : '生成单'}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="原始单" name="0"></el-tab-pane>
          <el-tab-pane label="生成单" name="1"></el-tab-pane>
        </el-tabs>

        <div class="ftabBtn flex">
          <!-- <el-button type="primary" size="small">导出</el-button> -->
          <el-button type="primary" size="small" @click="exportTaxDtl">导出结算单算税结果原始数据</el-button>
          <el-button type="success" size="small" @click="uploadHandel">上传</el-button>
          <el-button type="warning" size="small" v-if="activeName=='0'" @click="batchRefresh">获取刷新</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" @selection-change="handleSelectionChange" :max-height="tableHeight-100" v-loading="loading" style="width:100%">
          <el-table-column key="mul" type="selection" width="55" align="center" fixed="left"></el-table-column>
          <!-- <el-table-column prop="name" label="原始单编号" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='0'">
          </el-table-column> -->
          <el-table-column prop="generateNum" key="1" label="编号" min-width="140" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="projectName" key="2" label="项目/部门" min-width="160" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="incomeTaxMonth" key="3" label="个税申报月" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="attrMonth" key="3.1" label="归属月" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="applicationDate" key="3.2" label="发薪日" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="workProgress" key="4" label="工作进度" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="taxStatus" key="5" label="算税情况" v-if="activeName=='1'" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="payStatus" key="6" label="发薪状态" v-if="activeName=='1'" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" key="7" label="开票状态" v-if="activeName=='1'" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" key="8" label="邮件发送客户" v-if="activeName=='1'" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="createTime" key="9" label="创建时间" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="name" key="" label="创建方式" v-if="activeName=='1'" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column prop="originalSingleSourcePer" key="10" label="生成人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="originalSingleSource" key="11" label="原始单来源" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="originalSingleSource" key="12" label="原始单上传人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="remark" key="13" label="备注" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="originalSingleSource" key="14" label="发送邮箱" v-if="activeName=='0'" min-width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="receivingMailbox" key="15" label="接收邮箱" v-if="activeName=='0'" min-width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="mailSubject" key="16" label="邮件标题" v-if="activeName=='0'" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="mailContent" key="17" label="邮件内容" v-if="activeName=='0'" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="incomeTaxType" key="17.1" label="算税方式" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="originalOrder" key="18" label="原始单" min-width="160" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <div class="blueName cp" v-for="(item,index) in row.originalOrder" :key="index" @click="down(item.Url,row)">
                下载
                <i class="el-icon-document cp el-icon1" title="下载原始单"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="originalOrder" key="18.1" label="生成单（税前工资单）" min-width="160" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <div class="blueName cp" v-if="row.isPreTaxResult" @click="downMatchRes(row,1)">下载 <i class="el-icon-document cp el-icon1" title="下载原始单"></i></div>
            </template>
          </el-table-column>
          <el-table-column prop="originalOrder" key="18.2" label="生成单（税后工资单）" min-width="160" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <div class="blueName cp" v-if="row.isAfterTaxResult" @click="downMatchRes(row,2)">下载 <i class="el-icon-document cp el-icon1" title="下载原始单"></i></div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="generatorOrder" key="19" label="生成单" min-width="160" :show-overflow-tooltip="true" align="center" v-if="activeName=='1'">
            <template slot-scope="{row}">
              <div class="iconbox flex aic">
                {{ row.originalGenerTag=='1' ? '成功' : '失败' }}
                <i class="el-icon-document cp el-icon1" title="下载生成单" @click="downRes(row)"></i>
              </div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="originalGenerTag" key="20" label="创建生成单结果" v-if="activeName=='0'" min-width="120" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <div class="iconbox flex aic">
                {{ row.originalGenerTag=='1' ? '成功' : '失败' }}
                <i class="el-icon-document cp el-icon1" title="下载失败结果" @click="downRes(row)"></i>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="taxlog" key="21" label="失败原因" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="280" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="refreshHanel(row)" v-if="activeName=='0'">获取刷新</el-button>
                <el-button type="text" size="small" @click="createHandel(row)" v-if="activeName=='0'">创建生成单</el-button>
                <el-button type="text" size="small" @click="calcTax(row)" v-if="activeName=='0'">算税</el-button>
                <el-button type="text" size="small" @click="editHandel(row)">修改</el-button>
                <el-popconfirm title="请确定是否提交算薪" @confirm="submitSalary(row)" v-if="activeName=='1' && row.payStatus=='未提交'">
                  <el-button type="text" slot="reference" style="margin-left: 10px;">提交算薪</el-button>
                </el-popconfirm>
                <!-- <el-button type="text" size="small" v-if="activeName=='1'">提交开票</el-button> -->
                <el-popconfirm title="请确定是否作废" @confirm="del(row)">
                  <el-button type="text" slot="reference" style="margin-left: 10px;">作废</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 上传 -->
    <el-dialog :title="type=='upload' ? '上传原始单' : '修改'" :visible.sync="uploadVisible" width="640px" class="res_dialog enter_dialog">
      <el-form :rules="uploadRules" ref="uploadForm" :model="uploadQuery" class="" label-width="150px" size="small">
        <el-form-item label="项目:" prop="projectId">
          <el-select v-model="uploadQuery.projectId" placeholder="" style="width:300px" filterable clearable @change="changePro">
            <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="个税申报月:" prop="incomeTaxMonth">
          <el-date-picker v-model="uploadQuery.incomeTaxMonth" value-format="yyyy-MM" type="month" size="small" :picker-options="pickerOptions" placeholder="" style="width:300px" @change="getHistorySet"></el-date-picker>
        </el-form-item>
        <el-form-item label="归属月:" prop="attrMonth">
          <el-date-picker v-model="uploadQuery.attrMonth" value-format="yyyy-MM" type="month" size="small" placeholder="" style="width:300px"></el-date-picker>
        </el-form-item>
        <el-form-item label="发薪日:" prop="applicationDate">
          <el-select v-model="uploadQuery.applicationDate" placeholder="" size="small" style="width: 300px;" filterable>
            <el-option v-for="(item, index) in 31" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="算税方式" prop="incomeTaxType">
          <el-select v-model="uploadQuery.incomeTaxType" placeholder="" clearable filterable style="width:300px" @change="getHistorySet">
            <el-option value="正常工资薪金"></el-option>
            <el-option value="劳务报酬"></el-option>
            <el-option value="全年一次性奖金（一次扣税）"></el-option>
            <el-option value="全年多次性奖金（多次发放）"></el-option>
            <el-option value="解除劳动合同一次性补偿"></el-option>
            <el-option value="不算税"></el-option>
          </el-select>
        </el-form-item>
        <div class="tips" v-if="setList.length>0">系统已有同项目、同申报月、同算税方式生成单（{{ setList[0].createTime ? setList[0].createTime.replace('T',' ') : '' }}上传）</div>
        <el-form-item label="操作" v-if="type=='upload'">
          <el-select v-model="upType" placeholder="" filterable style="width:300px" @change="changeUpType">
            <el-option label="新增" :value="0"></el-option>
            <el-option label="替换之前文件" :value="1" v-if="setList.length>0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="选择替换文件" v-if="upType==1">
          <el-radio-group v-model="uploadQuery.id">
            <el-radio :label="item.id" v-for="(item,index) in setList" :key="index">编号：{{ item.generateNum }} 生成时间：{{ item.createTime.replace('T',' ') }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- <el-form-item label="请选择类型">
          <el-select v-model="upType" placeholder="" clearable filterable style="width:300px">
            <el-option value="税后工资单"></el-option>
            <el-option value="税前工资单"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="自动生成税后工资单" v-if="type=='upload' && upType==0 && uploadQuery.incomeTaxType && uploadQuery.incomeTaxType!='不算税'">
          <el-radio-group v-model="uploadQuery.isAutoAfterTaxPayroll">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
          <el-checkbox style="margin-left: 20px;" v-model="uploadQuery.isAutoAfterTaxToCustomer">自动回传客户</el-checkbox>
        </el-form-item>
        <!-- <el-form-item label="自动生成税前工资单" v-if="upType=='税后工资单' && uploadQuery.incomeTaxType!='不算税'">
          <el-radio-group v-model="uploadQuery.isAutoPreTaxPayroll">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
          <el-checkbox style="margin-left: 20px;" v-model="uploadQuery.isAutoPreTaxToCustomer">自动回传客户</el-checkbox>
        </el-form-item> -->
        <el-form-item label="自动生成核算单" v-if="type=='upload'">
          <el-radio-group v-model="uploadQuery.isAutoStateAccount">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
          <el-checkbox style="margin-left: 20px;" v-model="uploadQuery.isAutoStateAccountToCustomer">自动回传客户</el-checkbox>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="uploadQuery.remark" size="small" type="textarea" clearable style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="附件:" prop="files" v-if="type=='upload'">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="5" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">上传附件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入模板" v-if="type=='upload'">
          <div class="blueName cp" @click="downTemp">下载模板</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmUpload" size="small" :loading="isbtnLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    create
  } from "mathjs";
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import moment from "moment";
  export default {
    data() {
      return {
        pickerOptions: {
          disabledDate(time) {
            // 获取当前月份的第一天
            const today = new Date();
            const currentYear = today.getFullYear();
            const currentMonth = today.getMonth();

            // 如果年份小于当前年份，或者年份相同但月份小于当前月份，则禁用
            return time.getFullYear() < currentYear ||
              (time.getFullYear() === currentYear && time.getMonth() <= currentMonth);
          }
        },
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: 'updataTime',
              order: 1
            }]
          },
          // OriginalGenerTag: '0', //0为原始单1为生成单
          incomeTaxMonth: '',
          mailSubject: '',
          projectName: '',
          generateNum: '', //编号
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          receivingMailbox: '', //接收邮箱
          originalSingleSource: '', //发送邮箱
          acquireTimeStart: "",
          acquireTimeEnd: ""
        },
        uploadQuery: {
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          id: '',
          generateNum: '',
          projectName: '',
          projectId: null,
          attrMonth: '',
          applicationDate: '',
          incomeTaxMonth: '',
          incomeTaxType: '',
          remark: '',
          fileUrl: '',
          isAutoPreTaxPayroll: false, //税前工资单自动
          isAutoPreTaxToCustomer: false, //税前工资单自动回传客户
          isAutoAfterTaxPayroll: false, //税后工资单自动
          isAutoAfterTaxToCustomer: false, //税后工资单自动回传客户
          isAutoStateAccount: false, //对账单自动
          isAutoStateAccountToCustomer: false, //对账单回传客户
        },
        type: '',
        upType: 0,
        fileList: [],
        uploadVisible: false,
        isbtnLoading: false,
        showDropScreen: -1,
        activeName: '0',
        num1: 0,
        tableData: [],
        expandTable: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        projectList: [], //项目列表
        multipleSelection: [],
        permissionLists: [],
        uploadRules: {
          projectId: {
            required: true,
            message: '请选择项目',
            trigger: 'change'
          },
          incomeTaxMonth: {
            required: true,
            message: '请选择个税申报月',
            trigger: 'change'
          },
          attrMonth: {
            required: true,
            message: '请选择归属月',
            trigger: 'change'
          },
          applicationDate: {
            required: true,
            message: '请选择发薪日',
            trigger: 'change'
          },
          incomeTaxType: {
            required: true,
            message: '请选择算税方式',
            trigger: 'change'
          },
        },
        setList: []
      }
    },
    created() {
      this.getProList();
      this.getList();
      // this.getButtonPower();
    },
    methods: {
      checkPermission,
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.projectList = res.msg;
          } else {
            this.projectList = [];
          }
        });
      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      getList() {
        this.GetAdvancePageList();
      },
      GetAdvancePageList() {
        this.loading = true;
        xz.ArdCurStat(this.listQuery, 'GetFinalStateList').then(res => {
          if (res.status == 'ok') {
            res.data.data.forEach(e => {
              if (e.originalOrder != null && e.originalOrder) {
                e.originalOrder = eval(e.originalOrder)
              }
            });
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      down(url, row) {
        var path = this.$store.state.EMP.imgPath + url;
        const aTag = document.createElement("a");
        aTag.href = path;
        aTag.download = `${row.projectName}原始单-${moment(row.createTime).format('YYYY-MM-DD')}`;
        aTag.click();
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab() {
        if (this.activeName == '1') {
          this.listQuery.OriginalGenerTag = '1';
        } else {
          delete this.listQuery.OriginalGenerTag;
        }
        // this.listQuery.OriginalGenerTag = this.activeName == '0' ? '0' : '1';
        this.getList()
      },
      toDownFile(url) {
        const newWindow = window.open(url, "_blank");
      },
      // 表格多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      changePro(val) {
        let str = `?ProjectId=${val}`;
        xz.ArdCurStatGetFun('GetSettTaskConfig', str).then(res => {
          if (res.status == 'ok') {
            console.log(res.data);
          }
        })
        this.getHistorySet();
      },
      //获取同项目、申报月、申报方式的历史配置
      getHistorySet() {
        if (this.uploadQuery.projectId && this.uploadQuery.incomeTaxMonth && this.uploadQuery.incomeTaxType) {
          let str = `?ProjectId=${this.uploadQuery.projectId}&IncomeTaxMonth=${this.uploadQuery.incomeTaxMonth}&IncomeTaxType=${this.uploadQuery.incomeTaxType}`;
          xz.ArdCurStatGetFun('GetSettIncomeTaxMonthList', str).then(res => {
            if (res.status == 'ok') {
              this.setList = res.data;
            } else {
              this.setList = [];
            }
          })
        }
      },
      changeUpType(val) {
        if (val == 0) {
          this.uploadQuery.id = ''
        }
      },
      uploadHandel() {
        this.upType = 0;
        this.uploadQuery = this.$options.data.call(this).uploadQuery;
        this.fileList = [];
        this.type = 'upload';
        this.setList = [];
        this.uploadVisible = true;
      },
      downTemp() {
        let path = this.$store.state.EMP.tablePath + 'excel/caa39434-539c-40cb-95d6-31b215f0f9dc/E20250102163645505.xlsx';
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.download = "导入模版.xlsx";
        aTag.click();
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      // 删除附件
      handleFileRemove() {
        this.uploadQuery.fileUrl = '';
      },
      // 上传
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "entimg");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.uploadQuery.fileUrl = res
          } else {
            this.uploadQuery.fileUrl = ''
          }
        });
      },
      confirmUpload() {
        this.$refs["uploadForm"].validate((valid) => {
          if (valid) {
            if (this.type == 'upload' && !this.uploadQuery.fileUrl) {
              this.$message.warning('请选择上传文件！')
            } else if (this.upType == 1 && !this.uploadQuery.id) {
              this.$message.warning('请选择替换文件！')
            } else {
              this.isbtnLoading = true;
              xz.ArdCurStat(this.uploadQuery, 'AddDelUploadState').then(res => {
                if (res.status == 'ok') {
                  this.isbtnLoading = false;
                  this.getList();
                  this.uploadVisible = false;
                  this.$message.success("保存成功！");
                } else {
                  this.isbtnLoading = false;
                  this.$message.error(res.msg);
                }
              })
            }
          }
        });

      },
      refreshHanel(row) {
        this.confirmRefresh(row.projectId)
      },
      batchRefresh() {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          this.multipleSelection.forEach((e, i) => {
            arr.push(e.projectId)
            if (i == this.multipleSelection.length - 1) {
              let d = arr.toString();
              this.confirmRefresh(d);
            }
          });
        } else {
          this.$message.warning('请至少选择一条')
        }
      },
      confirmRefresh(id) {
        this.loading = true;
        xz.GetRefreshs(id).then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.loading = false;
            this.$message.success("刷新成功！");
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      createHandel(row) {
        this.loading = true;
        xz.CreateBuildOrder(row.id).then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.getList();
            this.$message.success("生成成功！");
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      editHandel(row) {
        this.type = 'edit';
        this.upType = 0;
        this.uploadQuery = {
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          id: row.id,
          generateNum: row.generateNum,
          projectName: row.projectName,
          projectId: row.projectId,
          incomeTaxMonth: row.incomeTaxMonth,
          attrMonth: row.attrMonth,
          applicationDate: row.applicationDate,
          incomeTaxType: row.incomeTaxType,
          remark: row.remark,
          isAutoPreTaxPayroll: false, //税前工资单自动
          isAutoPreTaxToCustomer: false, //税前工资单自动回传客户
          isAutoAfterTaxPayroll: false, //税后工资单自动
          isAutoAfterTaxToCustomer: false, //税后工资单自动回传客户
          isAutoStateAccount: false, //对账单自动
          isAutoStateAccountToCustomer: false, //对账单回传客户
        }
        this.uploadVisible = true;
      },
      //作废
      del(row) {
        this.loading = true;
        let str = `?id=${row.id}&OriginalGenerTag=${this.listQuery.OriginalGenerTag}`
        xz.ArdCurStatGetFun('FinalStatCancel', str).then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.getList();
            this.uploadVisible = false;
            this.$message.success("作废成功！");
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      //提交算薪
      submitSalary(row) {
        this.loading = true;
        let str = `?id=${row.id}`
        xz.ArdCurStatGetFun('FinalStatSubmitSalary', str).then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.getList();
            this.uploadVisible = false;
            this.$message.success("提交算薪成功！");
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      downRes(row) {
        // if (row.originalGenerTag == '1') {
        //   this.loading = true;
        //   let d = {
        //     Ids: row.id,
        //     Type: '2'
        //   }
        //   xz.payrollApplicationExport(d, this.roletype).then(res => {
        //     if (res.status == 'ok') {
        //       let url = res.data;
        //       let base64 = url.toString()
        //       let byteCharacters = atob(
        //         base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
        //       )
        //       let byteNumbers = new Array(byteCharacters.length)
        //       for (let i = 0; i < byteCharacters.length; i++) {
        //         byteNumbers[i] = byteCharacters.charCodeAt(i)
        //       }
        //       let byteArray = new Uint8Array(byteNumbers)
        //       let blob = new Blob([byteArray], {
        //         type: `application/pdf`
        //       })
        //       let aLink = document.createElement("a")
        //       aLink.download =  row.generateNum + '.xls';
        //       aLink.href = URL.createObjectURL(blob)
        //       aLink.click()
        //       this.loading = false;
        //     } else {
        //       this.loading = false;
        //       this.$message.error(res.msg)
        //     }
        //   })
        // } else {
        this.loading = true;
        let str = `?id=${row.id}`
        xz.ArdCurStatGetFun2('ExportGenerateMatchResult', str).then(res => {
          try {
            var data = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8"
            });
            var downloadUrl = window.URL.createObjectURL(data);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = `${row.projectName}生成单-${moment().format('YYYY-MM-DD')}.xlsx`;
            anchor.click();
            window.URL.revokeObjectURL(data);
            this.loading = false;
          } catch (e) {
            this.loading = false;
            this.$message.error('下载异常')
          }
        })
        // }
      },
      //算税
      calcTax(row) {
        let str = `?Id=${row.id}`;
        this.loading = true;
        xz.ArdCurStatGetFun('FinalStateStartCalaTax', str).then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.$message.success('开始算税成功！');
            this.getList();
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      downMatchRes(row, type) {
        this.loading = true;
        let str = `?Id=${row.id}&BusiTpye=${type}`;
        xz.ArdCurStatGetFun2('GenerateMatchResult2', str).then(res => {
          try {
            var data = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8"
            });
            var downloadUrl = window.URL.createObjectURL(data);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = `${row.projectName}-${type==1?'税前':'税后'}工资单-${moment().format('YYYY-MM-DD')}.xlsx`;
            anchor.click();
            window.URL.revokeObjectURL(data);
            this.loading = false;
          } catch (e) {
            this.loading = false;
            this.$message.error('下载异常')
          }
        })
      },
      //导出算税明细
      exportTaxDtl() {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          this.multipleSelection.forEach(element => {
            arr.push(element.id)
          });
          this.loading = true;
          xz.ExportSettTaxResult(arr.toString(), this.roletype).then(res => {
            if (res.status == 'ok') {
              let url = res.data;
              let base64 = url.toString()
              let byteCharacters = atob(
                base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
              )
              let byteNumbers = new Array(byteCharacters.length)
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
              }
              let byteArray = new Uint8Array(byteNumbers)
              let blob = new Blob([byteArray], {
                type: `application/excel;`
              })
              let aLink = document.createElement("a")
              aLink.download = `算税结果原始数据-${moment().format('YYYY-MM-DD')}.xls`; //这里写保存时的名称
              aLink.href = URL.createObjectURL(blob)
              aLink.click()
              this.loading = false;
            } else {
              this.loading = false;
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('请选择数据')
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .expandTable {
    padding-left: 50px;
  }

  .el-icon1 {
    color: #F59A23;
    font-size: 18px;
  }

  .iconbox {
    justify-content: center;
  }

  .tips {
    color: red;
    font-size: 14px;
    margin: 10px 0;
    padding-left: 80px;
  }
</style>
<style>
  .page_settlement .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_settlement .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_settlement .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_settlement .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_settlement .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_settlement .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>